import {UserDto, UsersApi} from '../../../api-client';
import {ErrorResponse} from '../../../common/types/errorRespose';
import {useMutation, UseMutationResult} from 'react-query';
import {UseMutationOptions} from "react-query/types/react/types";

type UseSearchUserById = (
  userApi: UsersApi,
  options?: UseMutationOptions<UserDto, ErrorResponse, string>
) => UseMutationResult<UserDto, ErrorResponse, string>;

export const useSearchUserById: UseSearchUserById = (userApi, options) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  return useMutation(
    async (id: string) => userApi.getUser(tenantId, id).then(res => res.data), options
  );
};
